export default __webpack_public_path__ + "static/media/section2-3-img1.127e33ea.png";